var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSouthEast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6777 17.6777C7.91458 27.4408 7.91458 43.2699 17.6777 53.033C27.4408 62.7961 43.2699 62.7961 53.033 53.033C62.7961 43.2699 62.7961 27.4408 53.033 17.6777C43.2699 7.91457 27.4408 7.91457 17.6777 17.6777Z",
    fill: "#1a76d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.349 44.7166L38.2451 23.4048C38.1053 22.9853 37.5298 22.9405 37.3266 23.3332L32.7754 32.1323C32.6328 32.4081 32.408 32.6328 32.1322 32.7755L23.3332 37.3267C22.9404 37.5298 22.9853 38.1053 23.4048 38.2451L44.7166 45.3491C45.1074 45.4794 45.4793 45.1075 45.349 44.7166Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthEast);
export default __webpack_public_path__ + "static/media/south-east.38706293fdc03243e205ee279cb55009.svg";
export { ForwardRef as ReactComponent };